import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        course: '=',
        occurrence: '=',
        occurrenceTrainings: '=',
        trainers: '=',
        trainingCompanies: '=',
        rooms: '=',
        participants: '=',
        trainingTimesWithParticipants: '=',
        courseVersion: '='
    },
    template: `
        <div>
            <courses-courses-edit-occurrence-steps-files
                course="vm.course"
                occurrence="vm.occurrence"
                occurrence-trainings="vm.occurrenceTrainings"
                trainers="vm.trainers"
                training-companies="vm.trainingCompanies"
                rooms="vm.rooms"
                participants="vm.participants"
                training-times-with-participants="vm.trainingTimesWithParticipants"
                course-version="vm.courseVersion"
            />
        </div>
    `
})
export default class {
}



// WEBPACK FOOTER //
// ./src/app/components/courses/courses/edit/occurrence/edit/files/index.js